import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';

import Button from '../../components/Button';
import Input from '../../components/Input';
import Select from '../../components/Select';

import { Container, ContainerFlex, ContainerRow } from './styles';

import api from '../../services/api';
import monthList from '../../services/monthList.json';

export default function AddDividend() {
  const navigation = useNavigate();

  const yearList = [
    {
      id: moment().subtract('years', 2).format('YYYY'),
      name: moment().subtract('years', 2).format('YYYY'),
    },
    {
      id: moment().subtract('years', 1).format('YYYY'),
      name: moment().subtract('years', 1).format('YYYY'),
    },
    { id: moment().format('YYYY'), name: moment().format('YYYY') },
    {
      id: moment().add('years', 1).format('YYYY'),
      name: moment().add('years', 1).format('YYYY'),
    },
  ];

  const [loading, setLoading] = useState(false);
  const [actives, setActives] = useState([]);

  const [activeId, setActiveId] = useState(null);
  const [paymentDate, setPaymentDate] = useState(moment().format('YYYY-MM-DD'));
  const [amount, setAmount] = useState(null);
  const [price, setPrice] = useState(null);
  const [periodMonth, setPeriodMonth] = useState(moment().format('MM'));
  const [periodYear, setPeriodYear] = useState(moment().format('YYYY'));

  const amountRef = useRef();
  const priceRef = useRef();

  useEffect(() => {
    loadActives();
  }, []);

  async function loadActives() {
    setLoading(true);

    try {
      const response = await api.get('/active');

      const activesNamed = response.data?.map((item) => ({
        ...item,
        name: item.code,
        code: item.name,
      }));
      setActives(activesNamed);
    } catch (error) {
      //alert('Erro ao buscar os ativos');
      toast.error('Erro ao buscar os ativos.');
      navigation(-1);
    } finally {
      setLoading(false);
    }
  }

  async function handleAddDividend() {
    if (activeId == null) return toast.error('Necessário informar o ativo.');
    if (paymentDate == null)
      return toast.error('Necessário informar a data de pagamento.');
    if (amount == null || amount == '')
      return toast.error('Necessário informar a quatindade.');
    if (price == null || price == '')
      return toast.error('Necessário informar o valor dos dividendos.');
    if (periodMonth == null || periodYear == null)
      return toast.error('Necessário informar o mês e ano dos dividendos.');

    setLoading(true);

    try {
      const response = await api.post('/dividends', {
        active_id: activeId,
        amount,
        price,
        payment_date: moment(paymentDate).format('YYYY-MM-DD'),
        period: `${periodMonth}-${periodYear}`,
      });

      const { msg } = response.data;
      toast.success(msg);
      clearFields();
    } catch (err) {
      toast.error(err.response.data.msg);
      clearFields();
    } finally {
      setLoading(false);
    }
  }

  function clearFields() {
    setActiveId(null);
    setAmount(null);
    setPrice(null);
    //setPeriodMonth(moment().format('MM'));
    //setPeriodYear(moment().format('YYYY'));

    document.getElementById('amount').value = null;
    document.getElementById('price').value = null;
  }

  function onChangeActive(item) {
    if (item == null) return setAmount(null);

    const amountByActive =
      actives.filter((i) => i.id == item)[0]?.amount || null;

    setActiveId(item);
    setAmount(amountByActive);

    if (amountByActive === null) {
      amountRef.current.focus();
    } else {
      priceRef.current.focus();
    }
  }

  return (
    <Container>
      <br />

      <h1>Cadastrar Dividendos</h1>
      <div style={{ height: 10 }} />

      <ContainerRow>
        <Select
          label="Ativo:"
          items={actives}
          selected={activeId}
          onChange={onChangeActive}
        />
        <div style={{ width: 20 }} />
        <Input
          id="paymentDate"
          type="date"
          label="Data Pagamento"
          value={paymentDate}
          onChange={setPaymentDate}
        />
      </ContainerRow>

      <ContainerRow>
        <Input
          id="amount"
          type="number"
          ref={amountRef}
          label="Quantidade"
          value={amount}
          onChange={setAmount}
        />
        <div style={{ width: 20 }} />
        <Input
          id="price"
          type="number"
          label="Dividendo (R$)"
          ref={priceRef}
          value={price}
          onChange={setPrice}
        />
        <div style={{ width: 20 }} />
        <Input
          type="number"
          label="Total (R$)"
          value={(amount * price).toFixed(2)}
          disabled
        />
      </ContainerRow>

      <ContainerRow>
        <Select
          label="Mês:"
          disabledNull
          items={monthList}
          selected={periodMonth}
          onChange={setPeriodMonth}
        />
        <div style={{ width: 20 }} />
        <Select
          label="Ano:"
          disabledNull
          items={yearList}
          selected={periodYear}
          onChange={setPeriodYear}
        />
      </ContainerRow>

      <br />
      <br />

      <ContainerRow>
        <Button
          text="Cadastrar"
          onPress={handleAddDividend}
          loading={loading}
        />
        <div style={{ width: 20 }} />
        <Button text="Voltar" onPress={() => navigation(-1)} />
      </ContainerRow>
    </Container>
  );
}
